import {GetStylesFunction, utils} from '@wallaby-ui/core';
import {Button, css, useTheme} from '@mui/material';
import {useIntl} from 'react-intl';
import {FC} from 'react';
import classNames from 'classnames';
import {ShortcutEnum} from '../../../lib/filtering';
import {Shortcut, Shortcuts} from '../../../lib/filtering/shortcut_types';

interface OwnProps {
  isDailyView?: boolean;
  onShortcutSelect: (dateRange: {start: Date; end: Date}, shortcut: ShortcutEnum | null) => void;
  activeShortcutButton: ShortcutEnum | null;
  setActiveShortcutButton: (activeShortcutButton: ShortcutEnum | null) => void;
  shortcuts: Shortcuts;
}

type Props = OwnProps;

export const FilterNodeRangeShortcuts: FC<Props> = (props: Props) => {
  const {isDailyView = true, onShortcutSelect, activeShortcutButton, setActiveShortcutButton, shortcuts} = props;

  const theme = useTheme();
  const muiStyles = getStyles({theme});
  const intl = useIntl();

  const handleShortcutButtonClick = (shortcut: Shortcut) => {
    onShortcutSelect(shortcut.getValue(), shortcut.label);
    setActiveShortcutButton(shortcut.label);
  };

  const getShortcutButton = (shortcut: Shortcut) => {
    if (typeof shortcut?.evaluateHidden === 'function' && shortcut.evaluateHidden()) {
      return null;
    }
    return (
      <Button
        variant='text'
        css={muiStyles.shortcutButton}
        className={classNames({
          shortcutButtonActive: activeShortcutButton === shortcut.label,
        })}
        key={shortcut.label}
        onClick={() => handleShortcutButtonClick(shortcut)}
      >
        {intl && utils.TranslateUtils.translate(`date.shortcuts.${shortcut.label.toLowerCase().replace(/_/g, '')}`, intl)}
      </Button>
    );
  };

  return (
    <div css={muiStyles.shortcutsWrapper}>
      {isDailyView
        ? shortcuts.dailyShortcuts.map((shortcut) => getShortcutButton(shortcut))
        : shortcuts.monthlyShortcuts.map((shortcut) => getShortcutButton(shortcut))}
      {shortcuts.commonShortcuts.map((shortcut) => getShortcutButton(shortcut))}
    </div>
  );
};

const getStyles: GetStylesFunction = (options) => ({
  shortcutsWrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${options?.theme?.spacing(1)};
  `,
  shortcutButton: css`
    font-family: var(--dlFontFamilyBold), serif;
    text-transform: none;
    font-size: ${options?.theme?.spacing(3.5)};
    color: var(--dlTheme-500);

    &:hover {
      background-color: var(--dlTheme-50);
    }

    &.shortcutButtonActive {
      background-color: var(--dlTheme-50);
    }
  `,
});
